import React from "react";

const NotFound = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 text-center bg-light">
      <h1 className="display-1 text-danger">404</h1>
      <h2 className="mb-3">Page Not Found</h2>
      <p className="text-muted">Oops! The page you're looking for doesn't exist.</p>
    </div>
  );
};

export default NotFound;
